import axios from "axios";

export const getTeamMemberList = async (token, id) => {
  const host = localStorage.getItem("host");
  const context = localStorage.getItem("context");
  const appToken = localStorage.getItem("appToken");
  return await axios.get(
    `https://${host}/${context}/mobileapp/teamMemberSearch.do?promotionId=${id}#/search/${appToken}`,
    {
      headers: {
        "content-type": "application/json",
        "originated": "teams",
        "post-type": "ajax",
        "outlookauth": appToken,
      },
    }
  );
};

export const getMemberSearchList = async (id, searchData, filters, recipient) => {
  const host = localStorage.getItem("host");
  const context = localStorage.getItem("context");
  const appToken = localStorage.getItem("appToken");
  const { jobTitle, department, country, location, group } = filters;
  const filterQuery = `&jobTitle=${jobTitle}&department=${department}&country=${country}&location=${location}&group=${group}`;
  return await axios
    .get(
      `https://${host}/${context}/mobileapp/outlook/recipientSearch.action?promotionId=${id}&recipientIds=${recipient}&lastName=${searchData}&firstName=${searchData}${filterQuery}#/search/${appToken}`,
      {
        headers: {
          "content-type": "application/json",
          "originated": "teams",
          "post-type": "ajax",
          "outlookauth": appToken,
        },
      }
    )
    .catch((error) => {
      if (error) {
        return error.response;
      }
    });
};

export const getEligiblePromotion = async () => {
  const host = localStorage.getItem("host");
  const context = localStorage.getItem("context");
  const appToken = localStorage.getItem("appToken");
  return await axios.get(
    `https://${host}/${context}/mobileapp/teams/eligiblePromotions.action`,
    {
      headers: {
        "content-type": "application/json",
        "originated": "teams",
        "post-type": "ajax",
        "outlookauth": appToken,
      },
    }
  );
};

export const getDepartment = async (searchData) => {
  const host = localStorage.getItem("host");
  const context = localStorage.getItem("context");
  const appToken = localStorage.getItem("appToken");
  return await axios
    .get(
      `https://${host}/${context}/mobileapp/outlook/department.action?department=${searchData}`,
      {
        headers: {
          "content-type": "application/json",
          "originated": "teams",
          "post-type": "ajax",
          "outlookauth": appToken,
        },
      }
    )
    .catch((error) => {
      if (error) {
        return error.response;
      }
    });
};

export const getLocation = async (searchData) => {
  const host = localStorage.getItem("host");
  const context = localStorage.getItem("context");
  const appToken = localStorage.getItem("appToken");
  return await axios
    .get(
      `https://${host}/${context}/mobileapp/outlook/location.action?location=${searchData}`,
      {
        headers: {
          "content-type": "application/json",
          "originated": "teams",
          "post-type": "ajax",
          "outlookauth": appToken,
        },
      }
    )
    .catch((error) => {
      if (error) {
        return error.response;
      }
    });
};

export const getCountry = async (searchData) => {
  const host = localStorage.getItem("host");
  const context = localStorage.getItem("context");
  const appToken = localStorage.getItem("appToken");
  return await axios
    .get(
      `https://${host}/${context}/mobileapp/outlook/country.action?country=${searchData}`,
      {
        headers: {
          "content-type": "application/json",
          "originated": "teams",
          "post-type": "ajax",
          "outlookauth": appToken,
        },
      }
    )
    .catch((error) => {
      if (error) {
        return error.response;
      }
    });
};

export const getGroup = async (searchData) => {
  const host = localStorage.getItem("host");
  const context = localStorage.getItem("context");
  const appToken = localStorage.getItem("appToken");
  return await axios
    .get(
      `https://${host}/${context}/mobileapp/outlook/group.action?group=${searchData}`,
      {
        headers: {
          "content-type": "application/json",
          "originated": "teams",
          "post-type": "ajax",
          "outlookauth": appToken,
        },
      }
    )
    .catch((error) => {
      if (error) {
        return error.response;
      }
    });
};

export const getJobTitle = async (searchData) => {
  const host = localStorage.getItem("host");
  const context = localStorage.getItem("context");
  const appToken = localStorage.getItem("appToken");
  return await axios
    .get(
      `https://${host}/${context}/mobileapp/outlook/jobTitle.action?jobTitle=${searchData}`,
      {
        headers: {
          "content-type": "application/json",
          "originated": "teams",
          "post-type": "ajax",
          "outlookauth": appToken,
        },
      }
    )
    .catch((error) => {
      if (error) {
        return error.response;
      }
    });
};
